import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Código ERP"
}, "Código ERP", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, { titulo: "Códigos" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_form_item, { label: "Código SKU" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "255",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedSku) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedSku]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, { label: "Código de barras (GTIN, EAN, ISBN, etc.)" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "50",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedCodigoBarras) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedCodigoBarras]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form_item, null, {
              label: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_a_tooltip, {
                  placement: "top",
                  title: "Código único para identificação no seu sistema de gestão."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icone, {
                      class: "ui-icone-informacao",
                      nome: "informacao-campo"
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "255",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedCodigoErp) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedCodigoErp]
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}